// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-logo[data-v-ac348084] {\n  flex-direction: column;\n}\n.maxSizingProgress[data-v-ac348084] {\n  display: flex;\n  justify-content: center;\n}\n.MeetingPage[data-v-ac348084] {\n  background-color: #f2f4f8;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 600px;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.buttonText[data-v-ac348084] {\n  font-size: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
